import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-copyright',
  templateUrl: './footer-copyright.component.html',
  styleUrl: './footer-copyright.component.scss'
})
export class FooterCopyrightComponent {
  getYear() {
    return new Date().getFullYear();
  }
}
